import { render, staticRenderFns } from "./OrderModificationRequestModal.vue?vue&type=template&id=bfbabe86&scoped=true"
import script from "./OrderModificationRequestModal.vue?vue&type=script&lang=ts"
export * from "./OrderModificationRequestModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderModificationRequestModal.vue?vue&type=style&index=0&id=bfbabe86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbabe86",
  null
  
)

export default component.exports